/* eslint-disable @typescript-eslint/no-unused-vars */
import { Scenario } from '@scenario/models/scenario.model';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';

export interface SelectedScenariosState {
  selectedScenarios: Scenario[];
}

const initialState: SelectedScenariosState = {
  selectedScenarios: [],
};

export const selectedScenariosSlice = createSlice({
  name: 'selectedScenarios',
  initialState,
  reducers: {
    saveSelectedScenarios: (state, action: PayloadAction<Scenario[]>) => {
      state.selectedScenarios = action.payload;
    },
    unselectAllScenarios: state => {
      state.selectedScenarios = [];
    },
  },
});

export const selectSelectedScenarios = createSelector(
  (state: RootState) => state,
  (state: RootState): Scenario[] => state.selectedScenarios.selectedScenarios,
);

export const { saveSelectedScenarios, unselectAllScenarios } = selectedScenariosSlice.actions;

export default selectedScenariosSlice.reducer;
